import { render } from "./AppComponent.vue?vue&type=template&id=0eb091d9"
import script from "./AppComponent.vue?vue&type=script&lang=js"
export * from "./AppComponent.vue?vue&type=script&lang=js"
script.render = render

export default script